/**
 * Deactivate / Restore payloads for the `UPDATE_MANY_X` bulk mutations.
 *
 * "Inactive" and "deleted" are two DIFFERENT states:
 *
 *   - is_active: false        → deactivated. Still a live row. Hidden from the
 *                               default list, revealed by the "Show Inactive"
 *                               checkbox, and restorable from the UI.
 *   - deleted_at: <timestamp> → soft-deleted (archived). Set ONLY by the Delete
 *                               (trash) action, which runs the backend's
 *                               `deleteOne` / `deleteMany` mutations.
 *
 * The backend's soft-delete middleware (backend `src/utils/softDelete.ts`) scopes
 * every read to `deleted_at: null`. So if Deactivate also stamped `deleted_at`,
 * the row would vanish from every query — "Show Inactive" (which only drops the
 * `is_active` filter) could never bring it back. Deactivate therefore touches
 * `is_active` and nothing else.
 */

export const deactivateData = () => ({
    is_active: { set: false },
});

export const restoreData = () => ({
    is_active: { set: true },
});
